import appEvents from 'constants/appEvents.constant';
import hotelEvents from '../config/hotel-events';

export default function HotelsHeaderController(
    $scope,
    $state,
    $rootScope,
    $stateParams,
    hotelsFactory,
    deviceDetector,
    userService,
    l10nService,
    timeService,
    premierInnFormChecker,
    travelodgeFormChecker,
    hotelResultService,
    hotelSearchResults
) {
    'ngInject';
            const vm = this;

            Object.assign(vm, {
                $onInit,
                isHeaderVisible: null,
                getTotalCount: hotelsFactory.getTotalCount,
                hideHeader,
                getMinPricePerDay,
                getMaxPricePerDay,
            });

            function $onInit() {
                vm.isHeaderVisible = true;
                vm.placeTypes = [];
                vm.filtersAvailable = !_.isEmpty(hotelSearchResults.Filters);
                watchMarkersChange();
            }

            const MONTHS_IN_ADVANCE = 11;
            const DEFAULT_SEARCH_RADIUS = 0;
            const regionalSettings = userService.getRegionalSettings();
            const initialParams = angular.copy(hotelsFactory.getFormData());
            const initialOptions = hotelsFactory.options;
            const address = hotelsFactory.address = hotelsFactory.address || initialParams.Location;
            const addressText = hotelsFactory.addressText;
            const altAddress = hotelsFactory.altAddress = hotelsFactory.altAddress || initialParams.Location;
            const initialCheckInDate = moment(initialParams.checkInDate, regionalSettings.dateFormat);
            const initialCheckOutDate = moment(initialParams.checkOutDate, regionalSettings.dateFormat);
            const convertedCheckInDate = initialCheckInDate.format(regionalSettings.shortMonthDateFormatMoment);
            const convertedCheckOutDate = initialCheckOutDate.format(regionalSettings.shortMonthDateFormatMoment);
            const resultsCount = hotelSearchResults.Total;
            let currentSearchData = {};

            $scope.MapText = false;

            function watchMarkersChange() {
                $scope.hotelSearchResults = hotelSearchResults;
                $scope.$watch('hotelSearchResults.Markers', (newValue) => {
                    vm.isMapHasMarkers = newValue && !!newValue.length;
                });
            }

            function getMinPricePerDay() {
                const searchResult = hotelsFactory.getSearchResults();
                return searchResult.minPricePerDay;
            }

            function getMaxPricePerDay() {
                const searchResult = hotelsFactory.getSearchResults();
                return searchResult.maxPricePerDay;
            }


            $scope.hideSorting = (deviceDetector.device === 'iphone' || !(hotelSearchResults.Hotels && hotelSearchResults.Hotels.length));

            $scope.maxTravellerAmount = hotelsFactory.maxTravellerAmount;

            $scope.headerCtrl = {
                params: initialParams,
                address,
                addressText,
                altaddress: altAddress,
                diffDates: initialCheckOutDate.diff(initialCheckInDate, 'days'),
                convertedCheckInDate,
                convertedCheckOutDate,
                resultsCount,
                pricePerDay: {
                    min: hotelSearchResults.MinimumPricePerDay,
                    max: hotelSearchResults.MaximumPricePerDay,
                },
            };

            $scope.headerSearchForm = {
                params: initialParams,
                options: initialOptions,
                address,
                addressText,
                altAddress,
                cityName: '',
            };

            $scope.hotelsFormChecker = {
                form: $scope.headerSearchForm,
                errorElementSelector: '.formWarnings',
                errorCheckers: [premierInnFormChecker, travelodgeFormChecker],
            };

            const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.headerSearchForm.params.checkInDate);
            const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.headerSearchForm.params.checkOutDate);

            $scope.optionsCI = {
                placeholder: l10nService.localize('Check-In'),
                required: true,
                months: 2,
                start: initialDepartDate,
                after: moment().add({days: -1}),
                before: moment().add({months: MONTHS_IN_ADVANCE}),
                dependentPikers: ['optionsCO'],
                shiftDependentDays: 1,
            };

            $scope.optionsCO = {
                placeholder: l10nService.localize('Check-Out'),
                required: true,
                months: 2,
                start: initialReturnDate,
                after: initialDepartDate,
                before: moment().add({months: MONTHS_IN_ADVANCE}),
            };

            $scope.toggleMap = function() {
                if (!hotelSearchResults.Markers.length) {
                    return;
                }
                $scope.MapText = !$scope.MapText;
                $rootScope.$broadcast(hotelEvents.HOTELS_TRIGGER_MAP_VISIBILITY);
            };

            function hideHeader() {
                vm.isHeaderVisible = false;
                currentSearchData = angular.copy($scope.headerSearchForm);
            }

            $scope.toggleSorting = function() {
                $scope.hideSorting = !$scope.hideSorting;
                $rootScope.$broadcast(hotelEvents.HOTELS_TRIGGER_HOTELS_SORTING);
            };

            $scope.toggleFilters = function() {
                $scope.showFilters = !$scope.showFilters;
                $rootScope.$broadcast(hotelEvents.HOTELS_TRIGGER_HOTEL_FILTERS);

                $rootScope.$broadcast(appEvents.REFRESH_SLIDER);
            };

            $scope.dummy = undefined;
            $scope.changeValue = function(name, selected) {
                $scope.headerSearchForm.params[name] = selected.value;
                if ($scope.maxTravellerAmount && $scope.headerSearchForm.options.occupantsSelected.value * $scope.headerSearchForm.options.roomsListSelected.value > $scope.maxTravellerAmount) {
                    $scope.hotelSearch.occupantsPerRoom.$setValidity('tooManyOccupants', false);
                } else {
                    $scope.hotelSearch.occupantsPerRoom.$setValidity('tooManyOccupants', true);
                }
            };

            $scope.findHotels = function() {
                hotelResultService
                    .getFilterProperties()
                    .forEach((filter) => delete $scope.headerSearchForm.params[filter]);

                hotelsFactory.address = $scope.headerSearchForm.address;
                hotelsFactory.altAddress = $scope.headerSearchForm.altAddress;
                hotelsFactory.administrativeAreaLevel1 = $scope.headerSearchForm.administrativeAreaLevel1 || $scope.headerSearchForm.params.administrativeAreaLevel1;
                hotelsFactory.countryCode = $scope.headerSearchForm.countryCode || $scope.headerSearchForm.params.countryCode;
                hotelsFactory.cityName = $scope.headerSearchForm.cityName || $scope.headerSearchForm.params.cityName;

                $scope.headerSearchForm.params.Location = hotelsFactory.address;
                $scope.headerSearchForm.params.administrativeAreaLevel1 = hotelsFactory.administrativeAreaLevel1;
                $scope.headerSearchForm.params.countryCode = hotelsFactory.countryCode;
                $scope.headerSearchForm.params.cityName = hotelsFactory.cityName;
                $scope.headerSearchForm.params.Radius = DEFAULT_SEARCH_RADIUS;
                $scope.headerSearchForm.params.HotelSorting = 0;

                if (_.intersection(vm.placeTypes, hotelsFactory.placeTypesWithId).length === 0) {
                    $scope.headerSearchForm.params.placeId = null;
                }

                if (_.intersection(vm.placeTypes, hotelsFactory.placeTypesWithId).length === 0) {
                    $scope.headerSearchForm.params.placeId = null;
                }

                $scope.headerSearchForm = angular.copy($scope.headerSearchForm);
                $scope.headerSearchForm.params.hotelName = '';

                hotelsFactory.refreshOptions($scope.headerSearchForm.options);
                $state.go('main.hotels.results', $scope.headerSearchForm.params, {reload: true, inherit: false});
            };

            $scope.cancelSearch = function() {
                vm.isHeaderVisible = true;
                $scope.headerSearchForm = angular.copy(currentSearchData);
                currentSearchData = {};
            };

    $scope.$watch('headerSearchForm.params.checkInDate', function() {
                const checkIn = moment($scope.headerSearchForm.params.checkInDate, regionalSettings.dateFormat);
                const checkOut = moment($scope.headerSearchForm.params.checkOutDate, regionalSettings.dateFormat);
                if (checkIn.isAfter(checkOut.add({days: -1}))) {
                    $scope.headerSearchForm.params.checkOutDate = null;
                }
            });
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotels-header-controller.js